import { Injectable } from "@angular/core";
import { ListMetadata } from "app/models/list-metadata.model";
import { Observable } from "rxjs";
import { HttpClientService } from "../httpClient/httpclient.service";
import { HttpParams } from "@angular/common/http";




export class ActiveCustomerCard {
  cardId: number;
  cardNo: string;
  cardType: string;
  customerCode: string;
  channelId: number;
  storeId: number;
  customerId: number;
  vCustomerId: number;
  companyDataId: any;
  flagBlackList: string;
  blackListDate: string | null;
  cardDateStart: string;
  blackListTime: string | null;
  reasonId: any;
  reasonCode: any;
  reasonDescription: any;
  cardLinkStatus: string;
  flg_state: string;
  flg_kf: any;
  flg_dpl: string;
  user_ins_id: any;
  ts_ins: any;
  user_upd_id: any;
  ts_upd: any;
  user_del_id: any;
  ts_del: any;
}

export class CardCustomerAssociation {
  hostCodeFullName: string;
  cardFlgBlkList: any;
  cardFlgState: any;
  cardId: number;
  cardNo: string;
  custFlgState: any;
  custHostFlgState: any;
  customerId: number;
  dateEnd: string;
  dateStart: string;
  errorMessage: any;
  flg_dpl: any;
  flg_kf: any;
  flg_state: any;
  fullNameCustomer: string;
  id: number;
  rcMessage: string;
  returnCode: string;
  storeAssociation: string;
  storeAssociationAddress: string;
  storeHostCode: any;
  storeRequest: string;
  storeRequestAddress: string;
  storeRequestId: number;
  ts_del: any;
  ts_ins: any;
  ts_upd: any;
  user_del_id: any;
  user_ins_id: any;
  user_upd_id: any;
  uuid: string;
  customerHostId: any;  // Aggiunto
  customerHostCode: any; // Aggiunto
}



@Injectable()
export class CardAssociationService {





   
    constructor(
        private http: HttpClientService
    ) { }

    baseUrl: string = '/koncentro-customers/';
    kontableUrl:string= '/koncentro-customers/customer-card-association/getCardCustomerAssociationList'

    private buildListParamsWithoutUUID(
        offset = null, limit = null, search?: Array<{ key: string, value: string }>,
        globalSearch?: string, sort?: string, sort_dir?: number, flg_state?: string
      ): HttpParams {
        let params: HttpParams = new HttpParams();
       
        if (search) {
            for (const filter of search) {
                if (filter.key !== 'UUID' && filter.value) {
                    params = params.set(filter.key, filter.value);
                }
            }
        }
        console.log("params before", params)
        if (sort) {
          params = params.set('sort', sort);
          params = params.set('sort_dir', sort_dir ? sort_dir.toString() : '1');
        }
    
    
        if (offset !== null) {
          params = params.set('offset', offset.toString());
        }
        if (limit !== null) {
          params = params.set('limit', limit.toString());
        }
        if (flg_state) {
          params = params.set('flg_state', flg_state);
        }
        console.log("params", params)
        return params;
      }
    

    //lista delle associazioni
    list(
        offset = null,
        limit = null,
        search?: Array<{ key: string, value: string }>,
        globalSearch?: string,
        sort?: string,
        sort_dir?: number
    ): Observable<{ data: Array<CardCustomerAssociation>, metadata: ListMetadata }> {
        const params = this.buildListParamsWithoutUUID(offset, limit, search, globalSearch, sort, sort_dir);
        let payload: any = {};;
        if (search) {
            for (const filter of search) {
                if (filter.key === 'UUID' && filter.value) {
                    payload = { uuid: filter.value };
                    break;
                }
            }
        }
        return this.http.postPaged(this.kontableUrl + '?' + params.toString(),payload);
    }
      //lista delle associazioni
 /*      list(
        offset = null,
        limit = null,
        search?: Array<{ key: string, value: string }>,
        globalSearch?: string,
        sort?: string,
        sort_dir?: number
    ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
        const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
        return this.http.getPaged(this.kontableUrl + '?' + params.toString());
    }
 */
    //Remember mi torna anche il messaggio di errore
    evaluateCardCustomerAssociation(uuid: string): Observable<CardCustomerAssociation> {
        const url = `${this.baseUrl}customer-card-association/evaluateCardCustomerAssociation`;
        return this.http.post(url, { uuid });
    }
    
    createCardCustomerAssociationLog(fieldModel: any): Observable<any> {
      const url = `${this.baseUrl}customer-card-association/createCardCustomerAssociationLog`;
      return this.http.post(url, fieldModel);
  }

  findActiveCard(idCustomer: number): Observable<any> {
    return this.http.get(`koncentro-customers/v2/customers/${idCustomer}/cards`);
  }

  sendEmail(id: number, customerId: number): Observable<any> {
    return this.http.get(`koncentro-customers/customer-card-association/sendNotificationMagnews/${customerId}/${id}`);
  }
  
  
  

}




// WEBPACK FOOTER //
// ./src/app/services/customer/card-association.service.ts